export default function PreviewAlert() {
  return (
    <div className="py-2 text-center text-xs text-gray-500 font-primary bg-orange-100">
      This page is a preview. Remember to save & publish your changes.
    </div>
  )
}
